'use client'

import { z } from 'zod'

const CONTEXT_KEY = 'veluvit:payment:popup'
const BILLING_CONTEXT_KEY = 'veluvit:billing:popup'
const contextSchema = z.object({ id: z.uuid(), orderId: z.string().min(1) })
export const paymentReturnSchema = contextSchema.extend({
  type: z.literal('veluvit.payment.return'),
})
const billingContextSchema = z.object({
  id: z.uuid(),
  setupId: z.string().min(1),
})

export function paymentModel(): 'WEB' | 'MOB' {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
    (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
    ? 'MOB'
    : 'WEB'
}

export function closePaymentPopup(popup: Window | null) {
  try {
    popup?.close()
  } catch {}
}

export function readPaymentPopupContext(orderId: string) {
  try {
    const parsed = contextSchema.safeParse(
      JSON.parse(sessionStorage.getItem(CONTEXT_KEY) ?? 'null')
    )
    return parsed.success && parsed.data.orderId === orderId
      ? parsed.data
      : null
  } catch {
    return null
  }
}

export function paymentPopupChannel(id: string) {
  return `veluvit:payment:${id}`
}

export function readBillingPopupContext(setupId: string) {
  try {
    const parsed = billingContextSchema.safeParse(
      JSON.parse(sessionStorage.getItem(BILLING_CONTEXT_KEY) ?? 'null')
    )
    return parsed.success && parsed.data.setupId === setupId
      ? parsed.data
      : null
  } catch {
    return null
  }
}
